import { cn } from '../../lib/utils';

/**
 * Shape-preserving loading placeholder. First loads render skeletons in the
 * real layout; refetches dim existing content instead (see DataTable).
 * The pulse animation is disabled globally under prefers-reduced-motion.
 */
function Skeleton({ className, ...props }: React.HTMLAttributes<HTMLDivElement>) {
  return <div className={cn('animate-pulse rounded-md bg-muted', className)} {...props} />;
}

export { Skeleton };
